module.exports = __webpack_public_path__ + "static/media/AWAY-on.8a8eb9df.svg";